"use client";

import React, { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Sheet, SheetContent, SheetTrigger, SheetTitle, SheetDescription, SheetHeader, SheetClose } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function DesktopMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden lg:flex items-center gap-6">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-4 w-20 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <NavigationMenu className="hidden lg:flex">
      <NavigationMenuList className="gap-6">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="group inline-flex h-9 w-max items-center justify-center rounded-md bg-transparent px-2 py-2 text-sm font-medium transition-colors hover:text-primary focus:text-primary focus:outline-none disabled:pointer-events-none disabled:opacity-50 data-[active]:bg-accent/50 data-[state=open]:bg-accent/50 relative">
                {item.label}
                <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-[var(--color-primary)] transition-all duration-300 group-hover:w-full" />
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 mt-8">
        {[1, 2, 3, 4].map(i => <div key={i} className="h-8 w-full bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-4 mt-8">
      {menuItems.map((item, i) => <div key={item.id} data-index={i} className="border-b border-border pb-2 last:border-0">
          <Link to={item.href || "#"} className="block text-lg font-medium text-foreground hover:text-primary transition-colors">
            <SheetClose className="w-full text-left">
                {item.label}
            </SheetClose>
          </Link>
        </div>)}
      <div className="mt-6 pt-6 border-t border-border">
        <Button asChild className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/90" size="lg">
          <Link to="#contact">
            Получить расчет
          </Link>
        </Button>
      </div>
    </nav>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 border-b ${isScrolled ? "bg-background/80 backdrop-blur-md border-border shadow-sm" : "bg-background border-border"}`}>
      <div className="container mx-auto px-4 h-20 flex items-center justify-between">
        {}
        <div className="flex-shrink-0">
          <Link to="/HomePage#" className="flex items-center gap-2">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1567030/img/agency_profi_official_logo.png" alt="Агенство ПРОФИ" className="h-7 w-auto object-contain" />
          </Link>
        </div>

        {}
        <div className="hidden lg:block">
          <MenuProvider menu_id="16">
            <DesktopMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex items-center gap-4">
          {}
          <div className="hidden lg:block">
            <Button asChild variant="secondary" className="font-semibold shadow-sm">
              <Link to="#contact">Получить расчет</Link>
            </Button>
          </div>

          {}
          <div className="lg:hidden">
            <Sheet>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" className="hover:bg-accent">
                  <Menu className="h-6 w-6" />
                  <span className="sr-only">Открыть меню</span>
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px] border-l border-border">
                <SheetHeader className="text-left">
                  <SheetTitle className="flex items-center gap-2">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1567030/img/agency_profi_official_logo.png" alt="Агенство ПРОФИ" className="h-6 w-auto" />
                  </SheetTitle>
                  <SheetDescription>
                    Навигация по сайту
                  </SheetDescription>
                </SheetHeader>
                
                <MenuProvider menu_id="16">
                  <MobileMenuConsumer />
                </MenuProvider>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>;
}